import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-minus-pure",
  "use": "icon-minus-pure-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-minus-pure\">\r\n  <path fill-rule=\"evenodd\" d=\"M18 10a1 1 0 01-1 1H3a1 1 0 110-2h14a1 1 0 011 1z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol